// src/auth/Login.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/Login.css';
import loginSvg from '../icons/undraw_secure-login_m11a.svg';
import logo from '../icons/logo.svg';

const Login = () => {
  const [role, setRole] = useState('');
  const navigate = useNavigate();

  const handleNavigate = (e) => {
    e.preventDefault();
    if (!role) return;
    navigate(`/portal/${role}`);
  };

  return (
    <div className="login-wrapper">
      <img src={logo} alt="School ERP Logo" className="company-logo1" />
      <div className="login-card">
        {/* Tracer lines for neon effect */}
        <div className="tracer top"></div>
        <div className="tracer right"></div>
        <div className="tracer bottom"></div>
        <div className="tracer left"></div>

        <div className="login-left">
          <div className="logo-header">
            
            <span className="company-name1">Semigon School ERP</span>
          </div>
          <h2>Welcome back</h2>
          <p>Please select your role to continue</p>
          <form onSubmit={handleNavigate}>
            <select value={role} onChange={(e) => setRole(e.target.value)} required>
              <option value="">Select Role</option>
              <option value="admin">Admin</option>
              <option value="teacher">Teacher</option>
              <option value="parent">Parent</option>
              <option value="superadmin">Super Admin</option>
            </select>
            <button type="submit">Sign in</button>
          </form>
        </div>

        <div className="login-right">
          <img src={loginSvg} alt="Secure login" />
        </div>
      </div>
    </div>
  );
};

export default Login;
